import * as http from '../http';
import { getTrackingData } from 'helpers';

const api = `${process.env.REACT_APP_REG_Api}/Performer`;

export const getPerformerTypes = () => {
  return http.get(`${api}/types`);
};

export const createPerformer = (
  payload: {
    performerTypeIds: number[];
    firstName: string;
    lastName: string;
    email: string;
    password: string;
  }
) => {
  // Freemium performer signup is a user-confirmed action: attach attribution.
  // Spread order keeps the real payload fields authoritative on collision.
  const body = { ...(getTrackingData() || {}), ...payload };
  return http.post(`${api}${window.location.search}`, body);
};
